import { MotionModal, ModalCloseButton } from "../../../../components/motion";

const SuccessModal = ({
  show,
  handleClose,
  successMessage
}) => {
  return (
    <MotionModal show={show} onClose={handleClose} maxWidthClassName="tw:max-w-[700px]" panelClassName="border-top-gold">
      <div className="tw:relative tw:flex-1 tw:p-4">
        <div className="tw:flex tw:justify-end">
          <ModalCloseButton isInline onClick={handleClose} />
        </div>
        <p className="tw:text-center fs-16 noto tw:mt-4">{successMessage}</p>
        <div className="tw:my-6">
          <div className="tw:flex tw:justify-center tw:gap-2">
            <button
              className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-transparent tw:border-[#dbbe78] tw:text-[#282828] tw:hover:bg-[#dbbe78] tw:hover:border-[#dbbe78] tw:hover:text-[#282828] tw:rounded-[0.375rem]"
              type="button"
              onClick={() => {
                handleClose();
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </MotionModal>
  );
};

export default SuccessModal;
